import { getUserInfo, updateUser, userStore } from '@source/store/user';
import { UserInfo } from '@source/store/user/utilities/store.types';

export const addUserAddress = () => {
    const userData = userStore.getState();
    const userInfo = getUserInfo() as UserInfo;

    updateUser({
        ...userData,
        info: {
            ...userInfo,
            zipcode: '1234AA',
            street: 'Voorstraat',
            houseNumber: '23',
            houseNumberSuffix: '',
            city: 'Amsterdam',
            phoneNumber: '0612345678',
            country: 'a0U2000000DuCWyEAN',
        },
    });
};
